module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v1-920.ef6e6226.png";